export default "__VITE_ASSET__DhYNjbId__"